import {
    GET_NOTES_FAIL,
    GET_NOTES_SUCCESS,
    ADD_NOTE_SUCCESS,
    ADD_NOTE_FAIL,
    UPDATE_NOTE_SUCCESS,
    UPDATE_NOTE_FAIL,
    DELETE_NOTE_SUCCESS,
    DELETE_NOTE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    notes: [],
    error: null,
    loading: true
};

const noteReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des notes
        case GET_NOTES_SUCCESS:
            return {
                ...state,
                notes: action.payload, // tableau d'objets note
                loading: false,
                error: null
            };

        case GET_NOTES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une notee
        case ADD_NOTE_SUCCESS:
            return {
                ...state,
                notes: [action.payload, ...state.notes], // ajoute au début du tableau
                error: null
            };

        case ADD_NOTE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une notee
        case UPDATE_NOTE_SUCCESS:
            return {
                ...state,
                notes: state.notes.map(note =>
                    note.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet note
                        : note
                ),
                error: null
            };

        case UPDATE_NOTE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une notee
        case DELETE_NOTE_SUCCESS:
            return {
                ...state,
                notes: state.notes.filter(
                    note => note.id !== action.payload
                ),
                error: null
            };


        case DELETE_NOTE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default noteReducer;
